import React, { useMemo, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { LicenseInfo } from '@mui/x-license';
import { createTheme, ThemeProvider } from '@mui/material';

import NoPage from './components/NoPage/NoPage';
import Layout from './components/Navbar/Layout';
import Auth from './components/Auth/Auth';
import ProtectedRoute from './components/ProtectedRoute';
import RoleIndex from './components/Roles/RoleIndex';
import { SimpleTaskMain } from './components/NewSimpleTask/SimpleTaskMain';
import { ProjectGroupForm } from './components/ProjectGroupListitems/ProjectGroupForm';
import { PriorityForm } from './components/Priority/PriorityForm';
import { UserForm } from './components/Users/UserForm';
import { MachineForm } from './components/Machines/MachineForm';
import TypeForm from './components/Type/TypeForm';
import MyTodoTable from './components/MyTodo/MyTodoTable';
import { LoaderProvider } from './provider/LoaderProvider';
import LoaderUI from './components/Interface/LoaderUI';
import KanbanView from './components/Kanban/KanbanView';
import TaskevaluationForm from './components/TaskEvaluation/TaskevaluationForm';
import TaskGanttForm from './components/TaskGantt/TaskGanttForm';
import { SimpleTaskPhoneForm } from './components/SimpleTaskPhone/SimpleTaskPhoneForm';
import SapResourcePlanner from './components/SapResourcePlanner/SapResourcePlanner';
import ActiveTimePage from './components/ActiveTime/ActiveTimePage';
import { OperationForm } from './components/Operation/OperationForm';
import QuantityUnitPage from './components/QuantityUnit/QuantityUnitPage';
import { TaskReportForm } from './components/TaskReport/TaskReportForm';
import { ProductionReportForm } from './components/ProductionReport/ProductionReportForm';
import { CompanyLocationForm } from './components/CompanyLocation/CompanyLocationForm';
import { PropertyForm } from './components/Property/PropertyForm';
import { InnovationForm } from './components/Innovation/InnovationForm';
import { AttendancePage } from './components/Attendance/AttendancePage';
import { AbsencePage } from './components/Absence/AbsencePage';
import { ResourceTwoPage } from './components/Resources/ResourceTwo/ResourceTwoPage';
import { ResourceThreePage } from './components/Resources/ResourceThree/ResourceThreePage';
import { ResourceFourPage } from './components/Resources/ResourceFour/ResourceFourPage';
import { ProjectResourcePlanner } from './components/ProjectResourcePlanner/ProjectResourcePlanner';
import { EmployeeResourcePlanner } from './components/EmployeeResourcePlanner/EmployeeResourcePlanner';
import { ProjectInfoPanelPage } from './components/ProjectInfoPanel/ProjectInfoPanelPage';
import { UserProfilePage } from './components/UserProfile/UserProfilePage';
import { ComplaintPage } from './components/ProductComplaint/ComplaintPage';
import SupplierComplaintPage from './components/SupplierComplaint/SupplierComplaintPage';
import CorrectionPage from './components/Correction/CorrectionPage';
import { FunnelView } from './components/Kanban/FunnelView';
import BiDataSourcePage from './components/BusinessIntelligence/BiDataSource/BiDataSourcePage';
import BiEditorPage from './components/BusinessIntelligence/BiEditor/BiEditorPage';
import BiQueryPage from './components/BusinessIntelligence/BiQueries/BiQueryPage';
import BiPage from './components/BusinessIntelligence/BiReport/BiPage';
import Dashboard from './components/BusinessIntelligence/Dashboard/Dashboard';
import DashboardAdmin from './components/BusinessIntelligence/Dashboard/DashboardAdmin';
import { ClassificationPage } from './components/Classification/ClassificationPage';
import { ProjectMain } from './components/Project/ProjectMain';
import { CalendarPage } from './components/Calendar/CalendarPage';
import { CrmTaskMain } from './components/CrmTask/CrmTaskMain';
import { PropertyGroupPage } from './components/PropertyGroup/PropertyGroupPage';
import { VehiclePlanPage } from './components/VehiclePlan/VehiclePlanPage';
import { VehicleResourcePlanner } from './components/VehiclePlan/VehiclePlanner/VehicleResourcePlanner';
import { HistoryPage } from './components/History/HistoryPage';
import SourceListPage from './components/SourceList/SourceListPage';
import { InterruptionReasonPage } from './components/InterruptionReason/InterruptionReasonPage';
import { DowntimeReasonPage } from './components/DowntimeReason/DowntimeReasonPage';

import ProductionMain from './components/Production/NewProduction/ProductionMain';
import { ItemPage } from './components/Item/ItemPage';
import { CheckListTemplatePage } from './components/CheckList/Template/CheckListTemplatePage';
import { CompanyPage } from './components/Company/CompanyPage';
import SapShiftLeaderReportPage from './components/SapShiftLeaderReport/SapShiftLeaderReportPage';
import ContactMapPage from './components/CrmTask/ContactMap/ContactMapPage';
import { PlanAbsencePage } from './components/PlanAbsence/PlanAbsencePage';
import { VatPage } from './components/Vat/VatPage';
import TaskListPlannerPage from './components/TaskListResourcePlanner/TaskListPlannerPage';
import { TaskListTemplatePage } from './components/TaskList/Template/TaskListTemplatePage';
import CurrencyPage from './components/Currency/CurrencyPage';
import VatCodePage from './components/VatCode/VatCodePage';
import CountryPage from './components/Country/CountryPage';
import LanguagePage from './components/Language/LanguagePage';
import { ResourceOneMain } from './components/Resources/NewResourceOne/ResourceOneMain';
import { JobMonitorPage } from './components/Jobmonitor/JobMonitorPage';
import { ExpiryMonitoringPage } from './components/ExpiryMonitoring/ExpiryMonitoringPage';
import FormPrintTemplate from './components/FormPrintTemplate/FormPrintTemplate';
import { PriceListPage } from './components/PriceList/PriceListPage';
import { PaymentMethodPage } from './components/PaymentMethod/PaymentMethodPage';
import { WarehousePage } from './components/Warehouse/WarehousePage';
import { CompanyGroupPage } from './components/CompanyGroup/CompanyGroupPage';
import ExchangeRatePage from './components/ExchangeRate/ExchangeRatePage';
import { ConfigPage } from './components/Config/ConfigPage';
import { KshClassificationPage } from './components/KshClassification/KshClassificationPage';
import { SalesOrPurchasePersonPage } from './components/SalesOrPurchasePerson/SalesOrPurchasePersonPage';
import { DeliveryMethodPage } from './components/DeliveryMethod/DeliveryMethodPage';
import { CostCenterPage } from './components/CostCenter/CostCenterPage';
import { ItemGroupPage } from './components/ItemGroup/ItemGroupPage';
import { IncotermPage } from './components/Incoterm/IncotermPage';
import OperationWidgetPage from './components/OperationWidget/OperationWidgetPage';
import { StatusMain } from './components/Status/StatusMain';
import { OperationGroupPage } from './components/OperationGroup/OperationGroupPage';
import TaskListTodoPage from './components/TaskListTodo/TaskListTodoPage';
import NewDocumentTypePage from './components/Document/newDocumentType/DocumentTypePage';
import { OpWidgetJobmonitorPage } from './components/Jobmonitor/OpWidgetJobmonitor/OpWidgetJobmonitorPage';
import { ProductionStatusPage } from './components/ProductionStatus/ProductionStatusPage';
import { Widget3Page } from './components/OperationWidget/Widget3Page';
import { OpWidgetJobmonitorPage2 } from './components/Jobmonitor/OpWidgetJobmonitor/OpWidgetJobmonitorPage2';
import { Widget4Page } from './components/OperationWidget/Widget4Page';
import { ConversionPage } from './components/Conversion/ConversionPage';
import { TemplateItemPage } from './components/TemplateItem/TemplateItemPage';
import { JobMonitorTaskAssigmentPage } from './components/JobmonitorTaskAssigment/JobMonitorTaskAssigmentPage';
import ProductionPlannerTable from './components/Client/VaradiMetal/ProductionPlannerTable/ProductionPlannerTable';
import OrderExecution from './components/OrderExecution/OrderExecution';
import { UserGroupPage } from './components/UserGroup/UserGroupPage';
import { FavouriteMenusPage } from './components/FavouriteMenus/FavouriteMenusPage';
import { EmployeePlannerMain } from './components/EmployeePlannerAbsence/EmployeePlannerMain';
import { Calendar } from './components/Client/ArtProof/Calendar/Calendar';
import { BuildingMain } from './components/Building/BuildingMain';
import { DailyReportPage } from './components/DailyReport/DailyReportPage';
import { ScrapReasonPage } from './components/ScrapReason/ScrapReasonPage';
import { SimpleTaskListPage } from './components/SimpleTaskList/SimpleTaskListPage';
import { ProjectTaskMain } from './components/ProjectTasks/ProjectTaskMain';
import { RecruitmentCalendarPage } from './components/RecruitmentCalendar/RecruitmentCalendarPage';
import { OtherExpensePage } from './components/OtherExpense/OtherExpensePage';
import { EmployeeActivityPage } from './components/EmployeeActivity/EmployeeActivityPage';
import { TaskFeedbackMain } from './components/TaskFeedback/TaskFeedbackMain';
import { ActivityLogTable } from './components/ActivityLog/ActivityLogTable';
import { ProgressMapPage } from './components/Client/VaradiMetal/ProgressMap/ProgressMapPage';
import { MasterdataClassificationPage } from './components/MasterdataClassification/MasterdataClassificationPage';
import { CompanyBreakPage } from './components/CompanyBreak/CompanyBreakPage';
import DynamicFormCreatorPage from './components/DynamicForm/DynamicFormCreatorPage';
import DynamicFormFiller from './components/DynamicForm/DynamicFormFiller';
import { NewOpWidgetJobmonitorPage } from './components/Jobmonitor/NewOpWidgetJobmonitor/NewOpWidgetJobmonitorPage';
import { NewJobMonitorTaskAssigmentPage } from './components/JobmonitorTaskAssigment/NewJobmonitorTaskAssigment/NewJobMonitorTaskAssigmentPage';
import FpProductionGeneratorPage from './components/Client/Folplast/ProductionGenerator/FpProductionGeneratorPage';
import DocumentContactMap from './components/newDoc/DocumentContactMap';
import { DocumentMain } from './components/newDoc/DocumentMain';
import SimpleTaskListPlannerPage from './components/SimpleTaskListResourcePlanner/SimpleTaskListPlannerPage';
import DiscountRulePage from './components/DiscountRule/DiscountRulePage';
import TaskResourcePlanner from './components/TaskResourcePlanner/TaskResourcePlanner';
import ProjectType from './components/ProjectType/ProjectTypePage';
import { TaskListReportPage } from './components/TaskListReport/TaskListReportPage';
import { ProjectTypeHomePage } from './components/ProjectTypeHome/ProjectTypeHomePage';
import WorkAreaPage from './components/WorkArea/WorkAreaPage';
import ServiceStatusPage from './components/ServiceStatus/ServiceStatusPage';
import ServiceTaskTypePage from './components/ServiceTaskType/ServiceTaskTypePage';
import { ServiceOperationPage } from './components/ServiceOperation/ServiceOperationPage';
import ServiceGroupPage from './components/ServiceGroup/ServiceGroupPage';
import { WorkSheetCreatorPage } from './components/WorkSheetCreator/WorkSheetCreatorPage';
import { ServiceJobMonitorTaskAssigmentPage } from './components/ServiceJobmonitorTaskAssigment/ServiceJobMonitorTaskAssigmentPage';
import { ServiceMain } from './components/ServiceCore/ServiceMain';
import DVTaskResourcePlanner from './components/Client/DelVill/TaskResourcePlanner/DVTaskResourcePlanner';
import { DVCalendar } from './components/Client/DelVill/Calendar/DVCalendar';
import { ComplaintReportPage } from './components/NewComplaint/ComplaintReport/ComplaintReportPage';
import ProjectTaskResourcePlanner from './components/Client/Caravan/ProjectTaskResourcePlanner/ProjectTaskResourcePlanner';
import ProductionGeneratorPage from './components/ProductionGenerator/ProductionGeneratorPage';
import ProductionGeneratorPartialPage from './components/ProductionGeneratorPartial/ProductionGeneratorPartialPage';
import ProductionItemProposalTable from './components/ProductionItemProposal/ProductionItemProposalTable';
import ServiceIssue from './components/ServiceCore/ServiceIssue';
import ServiceMonitorPage from './components/ServiceMonitor/ServiceMonitorPage';
import ComplaintReasonPage from './components/NewComplaint/ComplaintReason/ComplaintReasonPage';
import ComplaintTypePage from './components/NewComplaint/ComplaintType/ComplaintTypePage';
import ComplaintStatusPage from './components/NewComplaint/ComplaintStatus/ComplaintStatusPage';
import ComplaintResolutionPage from './components/NewComplaint/ComplaintResolution/ComplaintResolutionPage';
import ComplaintResolutionRequestPage from './components/NewComplaint/ComplaintResolutionRequest/ComplaintResolutionRequestPage';
import ComplaintActionTakenPage from './components/NewComplaint/ComplaintActionTaken/ComplaintActionTakenPage';
import ComplaintCorePage from './components/NewComplaint/ComplaintCore/ComplaintCorePage';
import ServiceReceipt from './components/ServiceCore/ServiceReceipt';
import ComplaintEffectPage from './components/NewComplaint/ComplaintEffect/ComplaintEffectPage';
import { MasterDataImportPage } from './components/MasterDataImport/MasterDataImportPage';
import HTaskListTodoPage from './components/Client/Hydro/TaskListTodo/HTaskListTodoPage';
import AlertFormPage from './components/Alert/AlertForm/AlertFormPage';
import { TaskCalendar } from './components/TaskCalendar/TaskCalendar';
import { BudgetPage } from './components/Budget/BudgetPage';
import { ResourceFivePage } from './components/Resources/ResourceFive/ResourceFivePage';
import DeliveryDraft from './components/ServiceCore/DeliveryDraft';
import { VatDeterminationPage } from './components/VatDetermination/VatDeterminationPage';
import { PlanTaskMain } from './components/PlanTask/PlanTaskMain';
import { PlanTaskReportForm } from './components/PlanTaskReport/PlanTaskReportForm';
import FpKanbanView from './components/Client/Folplast/Kanban/FpKanbanView';
import { SimpleTaskSchedulePage } from './components/SimpleTaskSchedule/SimpleTaskSchedulePage';
import { SettlementGeneratorPage } from './components/AttendanceSettlement/AttendanceSettlementGenerator/SettlementGeneratorPage';
import { AttendanceSettlementPage } from './components/AttendanceSettlement/AttendanceSettlementPage';
import { SzMOpWidgetJobmonitorPage } from './components/Client/Szikametro89/Jobmonitor/SzMOpWidgetJobmonitorPage';
import ConformityPage from './components/Client/VaradiMetal/Conformity/ConformityPage';

import { MenuProvider } from './context/MenuContext';
import { UsersProvider } from './context/UsersContext';
import { PageProvider } from './context/PageContext';
import { ParamProvider } from './context/ParamContext';
import { ConfigProvider } from './context/ConfigContext';
import { SimpleTaskDeadLineNotifyProvider } from './context/SimpleTaskDeadLineNotifyContext';
import { DocumentTypeRoutes } from './config/DocumentType';
import { ReportType } from './config/complaintReport';
import { THEMES } from './theme';
import ProductionMaterial from './components/ProductionMaterial/ProductionMaterial';

LicenseInfo.setLicenseKey(
  '04e17bafd89d1c6f9cedd9f20c771881Tz0xMjAzOTIsRT0xNzkyMTA4Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);

const App = () => {
  const [uiStyle, setUiStyle] = useState(localStorage.getItem('uiStyle') || 'style1');

  const saveStyle = (style) => {
    localStorage.setItem('uiStyle', style);
    setUiStyle(style);
  };

  const theme = useMemo(() => THEMES[uiStyle], [uiStyle]);

  return (
    <LoaderProvider>
      <PageProvider>
        <MenuProvider>
          <ParamProvider>
            <ConfigProvider>
              <UsersProvider>
                <SimpleTaskDeadLineNotifyProvider>
                  <ThemeProvider theme={theme}>
                    <LoaderUI />
                    <SnackbarProvider hideIconVariant>
                      <BrowserRouter>
                        <Routes>
                          <Route path="/" element={<Auth />} />
                          <Route path="/app" element={<ProtectedRoute element={<Layout />} />}>
                            <Route path="productionGenerator" element={<ProductionGeneratorPage />} />
                            <Route path="productionGeneratorPartial" element={<ProductionGeneratorPartialPage />} />
                            <Route path="orderExecution" element={<OrderExecution />} />
                            {Object.entries(DocumentTypeRoutes).map(([key, value]) => (
                              <Route key={key} path={value} element={<DocumentMain key={key} docTypeId={key} />} />
                            ))}
                            <Route path="newDocType" element={<NewDocumentTypePage />} />
                            <Route index element={<MyTodoTable />} />
                            <Route path="project/:id?" element={<ProjectMain />} />
                            <Route path="company/:id?" element={<CompanyPage />} />
                            <Route path="status" element={<StatusMain />} />
                            <Route path="projectGroup" element={<ProjectGroupForm />} />
                            <Route path="Categories" element={<PriorityForm />} />
                            <Route path="type" element={<TypeForm />} />
                            <Route path="machine" element={<MachineForm />} />
                            <Route path="operation" element={<OperationForm />} />
                            <Route path="quantityunit" element={<QuantityUnitPage />} />
                            <Route path="companylocation" element={<CompanyLocationForm />} />
                            <Route path="properties" element={<PropertyForm />} />
                            <Route path="complaint" element={<ComplaintPage />} />
                            <Route path="supplierComplaint" element={<SupplierComplaintPage />} />
                            <Route path="correction" element={<CorrectionPage />} />
                            <Route path="classification" element={<ClassificationPage />} />
                            <Route path="propertyGroup" element={<PropertyGroupPage />} />
                            <Route path="vehiclePlan" element={<VehiclePlanPage />} />
                            <Route path="item/:itemCode?" element={<ItemPage />} />
                            <Route path="checkListTemplate" element={<CheckListTemplatePage />} />
                            <Route path="taskListTemplate" element={<TaskListTemplatePage />} />
                            <Route path="sourcelist/:itemCode?" element={<SourceListPage />} />
                            <Route path="vat" element={<VatPage />} />
                            <Route path="currency" element={<CurrencyPage />} />
                            <Route path="vatCode" element={<VatCodePage />} />
                            <Route path="vatDetermination" element={<VatDeterminationPage />} />
                            <Route path="country" element={<CountryPage />} />
                            <Route path="formPrintTemplate" element={<FormPrintTemplate />} />
                            <Route path="language" element={<LanguagePage />} />
                            <Route path="priceList" element={<PriceListPage />} />
                            <Route path="paymentMethod" element={<PaymentMethodPage />} />
                            <Route path="warehouse" element={<WarehousePage />} />
                            <Route path="companyGroup" element={<CompanyGroupPage />} />
                            <Route path="kshClassification" element={<KshClassificationPage />} />
                            <Route path="salesOrPurchasePerson" element={<SalesOrPurchasePersonPage />} />
                            <Route path="deliveryMethod" element={<DeliveryMethodPage />} />
                            <Route path="costCenter" element={<CostCenterPage />} />
                            <Route path="itemGroup" element={<ItemGroupPage />} />
                            <Route path="exchangeRate" element={<ExchangeRatePage />} />
                            <Route path="incoterm" element={<IncotermPage />} />
                            <Route path="interruptionReason" element={<InterruptionReasonPage />} />
                            <Route path="downtimeReason" element={<DowntimeReasonPage />} />
                            <Route path="operationWidget" element={<OperationWidgetPage />} />
                            <Route path="operationWidget2_old" element={<OpWidgetJobmonitorPage2 />} />
                            <Route path="widget3" element={<Widget3Page />} />
                            <Route path="widget4" element={<Widget4Page />} />
                            <Route path="operationGroup" element={<OperationGroupPage />} />
                            <Route path="taskListTodo" element={<TaskListTodoPage />} />
                            <Route path="productionStatus" element={<ProductionStatusPage />} />
                            <Route path="conversion" element={<ConversionPage />} />
                            <Route path="templateItem" element={<TemplateItemPage />} />
                            <Route path="jobmonitorTaskAssigment_old" element={<JobMonitorTaskAssigmentPage />} />
                            <Route path="userGroup" element={<UserGroupPage />} />
                            <Route path="favouriteMenus" element={<FavouriteMenusPage />} />
                            <Route path="employeePlannerAbsence" element={<EmployeePlannerMain />} />
                            <Route path="building" element={<BuildingMain />} />
                            <Route path="dailyReport" element={<DailyReportPage />} />
                            <Route path="scrapReason" element={<ScrapReasonPage />} />
                            <Route path="projectTasks/:id?" element={<ProjectTaskMain />} />
                            <Route path="recruitmentCalendar" element={<RecruitmentCalendarPage />} />
                            <Route path="otherExpense" element={<OtherExpensePage />} />
                            <Route path="employeeActivity" element={<EmployeeActivityPage />} />
                            <Route path="taskFeedback/:id?" element={<TaskFeedbackMain />} />
                            <Route path="activityLog" element={<ActivityLogTable />} />
                            <Route path="masterdataClassification" element={<MasterdataClassificationPage />} />
                            <Route path="companyBreak" element={<CompanyBreakPage />} />
                            <Route path="employeeMonitor" element={<NewOpWidgetJobmonitorPage />} />
                            <Route path="locationGroupMonitor" element={<NewJobMonitorTaskAssigmentPage />} />
                            <Route path="discountRule" element={<DiscountRulePage />} />
                            <Route path="taskListReport" element={<TaskListReportPage />} />
                            <Route path="projectTypeHomePage" element={<ProjectTypeHomePage />} />
                            <Route path="workArea" element={<WorkAreaPage />} />
                            <Route path="serviceStatus" element={<ServiceStatusPage />} />
                            <Route path="serviceTaskType" element={<ServiceTaskTypePage />} />
                            <Route path="serviceOperation" element={<ServiceOperationPage />} />
                            <Route path="serviceGroup" element={<ServiceGroupPage />} />
                            <Route path="service/:id?" element={<ServiceMain />} />
                            <Route path="serviceIssue" element={<ServiceIssue />} />
                            <Route path="serviceReceipt" element={<ServiceReceipt />} />
                            <Route path="deliveryDraft" element={<DeliveryDraft />} />
                            <Route path="workSheetCreator" element={<WorkSheetCreatorPage />} />
                            <Route
                              path="serviceJobmonitorTaskAssigment"
                              element={<ServiceJobMonitorTaskAssigmentPage />}
                            />
                            <Route path="serviceMonitor" element={<ServiceMonitorPage />} />
                            <Route path="budget" element={<BudgetPage />} />
                            <Route path="attendanceSettlementGenerator" element={<SettlementGeneratorPage />} />
                            <Route path="attendanceSettlement" element={<AttendanceSettlementPage />} />

                            <Route path="resourceOne/:id?" element={<ResourceOneMain />} />
                            <Route path="resourceTwo" element={<ResourceTwoPage />} />
                            <Route path="resourceThree" element={<ResourceThreePage />} />
                            <Route path="resourceFour" element={<ResourceFourPage />} />
                            <Route path="resourceFive" element={<ResourceFivePage />} />

                            <Route path="simpleTask/:simpleTaskId?" element={<SimpleTaskMain />} />
                            <Route path="planTask/:id?" element={<PlanTaskMain />} />
                            <Route path="mytodo" element={<MyTodoTable />} />
                            <Route path="simpleTaskPhone" element={<SimpleTaskPhoneForm />} />
                            <Route path="production/:id?" element={<ProductionMain />} />
                            <Route path="productionMaterial" element={<ProductionMaterial />} />
                            <Route path="taskReport" element={<TaskReportForm />} />
                            <Route path="planTaskReport" element={<PlanTaskReportForm />} />
                            <Route path="productionreport/:prodOperationId?" element={<ProductionReportForm />} />
                            <Route path="innovation" element={<InnovationForm />} />
                            <Route path="absence" element={<AbsencePage />} />
                            <Route path="attendance" element={<AttendancePage />} />
                            <Route path="crmTask/:id?" element={<CrmTaskMain />} />
                            <Route path="planAbsence" element={<PlanAbsencePage />} />
                            <Route path="jobMonitor" element={<JobMonitorPage />} />
                            <Route
                              path="opWidgetJobMonitor/:operationId?/:userId?"
                              element={<OpWidgetJobmonitorPage />}
                            />
                            <Route
                              path="opWidgetJobMonitor2/:operationId?/:userId?/:resourceOneId?"
                              element={<OpWidgetJobmonitorPage2 />}
                            />

                            <Route path="user" element={<UserForm />} />
                            <Route path="roles" element={<RoleIndex />} />
                            <Route path="config" element={<ConfigPage />} />

                            <Route path="projectResourcePlanner" element={<ProjectResourcePlanner />} />
                            <Route path="employeeResourcePlanner" element={<EmployeeResourcePlanner />} />
                            <Route path="projectInfoPanel" element={<ProjectInfoPanelPage />} />
                            <Route path="userProfile" element={<UserProfilePage saveStyle={saveStyle} />} />
                            <Route path="calendarView" element={<CalendarPage />} />
                            <Route path="vehiclePlanner" element={<VehicleResourcePlanner />} />
                            <Route path="taskListResourcePlanner" element={<TaskListPlannerPage />} />
                            <Route path="simpleTaskListResourcePlanner" element={<SimpleTaskListPlannerPage />} />
                            <Route path="expiryMonitoring" element={<ExpiryMonitoringPage />} />
                            <Route path="simpleTaskList" element={<SimpleTaskListPage />} />
                            <Route path="projectType" element={<ProjectType />} />
                            <Route path="masterDataImport" element={<MasterDataImportPage />} />
                            <Route path="taskCalendar" element={<TaskCalendar />} />
                            <Route path="simpleTaskSchedule" element={<SimpleTaskSchedulePage />} />

                            <Route path="taskkanban/:subMenuName?/:projectTypeId?" element={<KanbanView />} />
                            <Route path="funnelView" element={<FunnelView />} />
                            <Route path="taskevaluation" element={<TaskevaluationForm />} />
                            <Route path="taskgantt" element={<TaskGanttForm />} />
                            <Route path="taskResourcePlanner" element={<TaskResourcePlanner />} />
                            <Route path="contactMap/:companyId?/:id?" element={<ContactMapPage />} />
                            <Route path="docContactMap/:docTypeId?/:docId?" element={<DocumentContactMap />} />

                            <Route path="activeTime" element={<ActiveTimePage />} />
                            <Route path="sapresourceplanner" element={<SapResourcePlanner />} />
                            <Route path="sapshiftleaderreport" element={<SapShiftLeaderReportPage />} />

                            <Route path="history" element={<HistoryPage />} />

                            <Route path="bi">
                              <Route path="datasource" element={<BiDataSourcePage />} />
                              <Route path="query" element={<BiQueryPage />} />
                              <Route path="editor/:reportId?" element={<BiEditorPage />} />
                              <Route path="biPage/:reportId" element={<BiPage />} />
                            </Route>
                            <Route path="dashboard/:dashboardId" element={<Dashboard />} />
                            <Route path="dashboardAdmin" element={<DashboardAdmin />} />

                            <Route path="varadiMetal">
                              <Route path="productionPlanner" element={<ProductionPlannerTable />} />
                              <Route path="progressMap" element={<ProgressMapPage />} />
                              <Route path="conformity" element={<ConformityPage />} />
                            </Route>

                            <Route path="folplast">
                              <Route path="productionGenerator" element={<FpProductionGeneratorPage />} />
                              <Route path="taskkanban" element={<FpKanbanView />} />
                            </Route>

                            <Route path="artProof">
                              <Route path="calendar" element={<Calendar />} />
                            </Route>

                            <Route path="delVill">
                              <Route path="taskResourcePlanner" element={<DVTaskResourcePlanner />} />
                              <Route path="calendar" element={<DVCalendar />} />
                            </Route>

                            <Route path="caravan">
                              <Route path="projectTaskResourcePlanner" element={<ProjectTaskResourcePlanner />} />
                            </Route>

                            <Route path="hydro">
                              <Route path="taskListTodo" element={<HTaskListTodoPage />} />
                            </Route>

                            <Route path="szikametro">
                              <Route path="jobmonitor" element={<SzMOpWidgetJobmonitorPage />} />
                            </Route>

                            <Route path="productionItemProposal" element={<ProductionItemProposalTable />} />

                            <Route path="dynamicFormCreator" element={<DynamicFormCreatorPage />} />
                            <Route path="dynamicFormFiller" element={<DynamicFormFiller />} />

                            <Route path="newComplaint">
                              <Route path="complaintReason" element={<ComplaintReasonPage />} />
                              <Route path="complaintType" element={<ComplaintTypePage />} />
                              <Route path="complaintStatus" element={<ComplaintStatusPage />} />
                              <Route path="complaintResolution" element={<ComplaintResolutionPage />} />
                              <Route path="complaintResolutionRequest" element={<ComplaintResolutionRequestPage />} />
                              <Route path="complaintActionTaken" element={<ComplaintActionTakenPage />} />
                              <Route path="complaintCore" element={<ComplaintCorePage />} />
                              <Route path="complaintEffect" element={<ComplaintEffectPage />} />
                            </Route>

                            <Route
                              path="complaintReport4D"
                              element={<ComplaintReportPage type={ReportType.REPORT4D} />}
                            />
                            <Route
                              path="complaintReport8D"
                              element={<ComplaintReportPage type={ReportType.REPORT8D} />}
                            />

                            <Route path="alertForm" element={<AlertFormPage />} />

                            <Route path="*" element={<NoPage />} />
                          </Route>
                        </Routes>
                      </BrowserRouter>
                    </SnackbarProvider>
                  </ThemeProvider>
                </SimpleTaskDeadLineNotifyProvider>
              </UsersProvider>
            </ConfigProvider>
          </ParamProvider>
        </MenuProvider>
      </PageProvider>
    </LoaderProvider>
  );
};

export default App;
